export default {
  AgainTrain: '/v3/serveScore/new/updateBakeAgainTrain',
  getMainData: '/v3/serveScore/new/bakeAgainTrain'
}
